import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import ConfiguracoesModulos from './pages/ConfiguracoesModulos'
import ConfiguracoesPortalAtendimento from './pages/Configuracoes/PortalAtendimento'
import Usuarios from './pages/Usuarios'
import ComercialContatosPortal from './pages/Comercial/ContatosPortal'
import LeitorArquivos from './pages/LeitorArquivos'
import PasiGPT from './pages/PasiGPT'
import SilvIA from './pages/SilvIA'
import AtendimentoAnalise from './pages/AtendimentoAnalise'
import ConfiguracoesAgendamentos from './pages/ConfiguracoesAgendamentos'
import ConfiguracoesNotificacoes from './pages/Configuracoes/Notificacoes'
import ConfiguracoesLogs from './pages/Configuracoes/Logs'
import ConfiguracoesMonitoramento from './pages/Configuracoes/Monitoramento'
import ConfiguracoesEmail from './pages/Configuracoes/Email'
import Whatsapp from './pages/Whatsapp'
import WhatsappFarma from './pages/WhatsappFarma'
import WhatsappCentralAmparo from './pages/WhatsappCentralAmparo'
import WikiArtigos from './pages/WikiArtigos'
import WikiGerenciar from './pages/WikiGerenciar'
import WikiBiblioteca from './pages/WikiBiblioteca'
import BaseConhecimento from './pages/IA/BaseConhecimento'
import PromptsAgentes from './pages/IA/PromptsAgentes'
import FluxoN8n from './pages/IA/FluxoN8n'
import IADocumento from './pages/IA/IADocumento'
import Circulando from './pages/Circulando'
import Imprensa from './pages/Imprensa'
import Interno from './pages/Interno'
import Boletim from './pages/Boletim'
import ProjetosRoadmap from './pages/Projetos/Roadmap'
import ProjetosGestao from './pages/Projetos/Gestao'
import CCTLista from './pages/CCTLista'
import CCTImportar from './pages/CCTImportar'
import CCTCoberturasDicionario from './pages/CCTCoberturasDicionario'
import CCTSDashboardScgp from './pages/CCTSDashboardScgp'
import CCTClausulas from './pages/CCTClausulas'
import CCTBuscarDados from './pages/CCTBuscarDados'
import MensagensAtivas from './pages/MensagensAtivas'
import MiddlewareParceiros from './pages/MiddlewareParceiros'
import SuperappDashboard from './pages/SuperappDashboard'
import DashboardClientes from './pages/DashboardClientes'
import DashboardCorretor from './pages/DashboardCorretor'
import Shop from './pages/Shop'
import PortaisAtendimento from './pages/PortaisAtendimento'
import AgentesIAConsumo from './pages/AgentesIAConsumo'
import Zendesk from './pages/Zendesk'
import AgentesIAAgenteZendesk from './pages/AgentesIAAgenteZendesk'
import GerarAudio from './pages/GerarAudio'
import ComercialCupons from './pages/Comercial/Cupons'
import ComercialGestao from './pages/Comercial/Gestao'
import ComercialAtualizacaoCadastral from './pages/Comercial/AtualizacaoCadastral'
import ComercialCampanhas2026 from './pages/Comercial/Campanhas2026'
import ComercialCalculadoras from './pages/Comercial/Calculadoras'
import ComercialCadastro from './pages/Comercial/Cadastro'
import ComercialClientes from './pages/Comercial/Clientes'
import ComercialClienteConta from './pages/Comercial/ClienteConta'
import ComercialAtividades from './pages/Comercial/Atividades'
import ComercialCotacoes from './pages/Comercial/Cotacoes'
import ComercialCockpit from './pages/Comercial/ComercialCockpit'
import AdmDespesas from './pages/Adm/Despesas'
import AdmCadastros from './pages/Adm/Cadastros'
import AdmDashboard from './pages/Adm/Dashboard'
import QualidadeCadastro from './pages/Qualidade/Cadastro'
import QualidadeIncidentes from './pages/Qualidade/Incidentes'
import QualidadeDashboard from './pages/Qualidade/Dashboard'
import QualidadeFluxograma from './pages/Qualidade/Fluxograma'
import QualidadeFluxogramaLista from './pages/Qualidade/FluxogramaLista'
import QualidadeFluxogramaEditor from './pages/Qualidade/FluxogramaEditor'
import SocialPosts from './pages/Social/Posts'
import MarketingClipping from './pages/Marketing/Clipping'
import MarketingAlertas from './pages/Marketing/Alertas'
import MarketingParametros from './pages/Marketing/Parametros'
import MarketingGame from './pages/Marketing/Game'
import MarketingSolicitacao from './pages/Marketing/Solicitacao'
import MarketingContratos from './pages/Marketing/Contratos'
import MarketingPropostas from './pages/Marketing/Propostas'
import MarketingNotas from './pages/Marketing/Notas'
import MarketingFinanceiro from './pages/Marketing/Financeiro'
import MarketingDespesas from './pages/Marketing/Despesas'
import MarketingMateriais from './pages/Marketing/Materiais'
import MarketingRelatorios from './pages/Marketing/Relatorios'
import CentralAmparoDashboard from './pages/CentralAmparo/Dashboard'
import CentralAmparoCalendario from './pages/CentralAmparo/Calendario'
import CentralAmparoTriagem from './pages/CentralAmparo/Triagem'
import CentralAmparoParametros from './pages/CentralAmparo/Parametros'
import FinanceiroPeL from './pages/Financeiro/PeL'
import EstoqueGestao from './pages/Estoque/Gestao'
import Manutencao from './pages/Manutencao'
import { AuthProvider } from './contexts/AuthContext'
import { NotificationsProvider } from './contexts/NotificationsContext'
import ProtectedRoute from './components/ProtectedRoute'
import AppLayout from './components/AppLayout'
import UpdateAvailableBanner from './components/UpdateAvailableBanner'
import { useAppUpdate } from './hooks/useAppUpdate'
import { isMaintenanceMode } from './utils/maintenanceMode'
import './App.css'

function AppUpdateLayer() {
  const { updateAvailable, deployedVersion, dismiss, reload } = useAppUpdate()

  return (
    <UpdateAvailableBanner
      visible={updateAvailable}
      deployedVersion={deployedVersion}
      onReload={reload}
      onDismiss={dismiss}
    />
  )
}

function App() {
  if (isMaintenanceMode()) {
    return <Manutencao />
  }

  return (
    <AuthProvider>
      <NotificationsProvider>
      <Router>
        <AppUpdateLayer />
        <div className="App">
          <Routes>
            {/* Rotas publicas (sem Sidebar) */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Rotas autenticadas (layout com Sidebar persistente) */}
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/atendimentos/resposta-zendesk" element={<AgentesIAAgenteZendesk />} />
              <Route path="/ia/consumo" element={<AgentesIAConsumo />} />
              <Route path="/configuracoes/usuarios" element={<Usuarios />} />
              <Route path="/configuracoes/modulo" element={<ConfiguracoesModulos />} />
              <Route path="/configuracoes/portalatendimento" element={<ConfiguracoesPortalAtendimento />} />
              <Route path="/superapp/middleware-parceiros" element={<MiddlewareParceiros />} />
              <Route path="/superapp/dashboard" element={<SuperappDashboard />} />
              <Route path="/ccts/lista" element={<CCTLista />} />
              <Route path="/ccts/coberturas-dicionario" element={<CCTCoberturasDicionario />} />
              <Route path="/ccts/importar" element={<CCTImportar />} />
              <Route path="/ccts/dashboardscgp" element={<CCTSDashboardScgp />} />
              <Route path="/ccts/clausulas" element={<CCTClausulas />} />
              <Route path="/ccts/buscar-dados" element={<CCTBuscarDados />} />
              <Route path="/documentos/leitor" element={<LeitorArquivos />} />
              <Route path="/pasigpt" element={<PasiGPT />} />
              <Route path="/atendimentos/silvia" element={<SilvIA />} />
              <Route path="/atendimentos/whatsapp" element={<Whatsapp />} />
              <Route path="/atendimentos/whatsapp-farma" element={<WhatsappFarma />} />
              <Route path="/atendimentos/whatsapp-central-amparo" element={<WhatsappCentralAmparo />} />
              <Route path="/atendimentos/zendesk" element={<Zendesk />} />
              <Route path="/portais/dashboard_cliente" element={<DashboardClientes />} />
              <Route path="/portais/dashboard_corretor" element={<DashboardCorretor />} />
              <Route path="/portais/shop" element={<Shop />} />
              <Route path="/portais/atendimento" element={<PortaisAtendimento />} />
              <Route path="/atendimentos/analise" element={<AtendimentoAnalise />} />
              <Route path="/configuracoes/agendamentos" element={<ConfiguracoesAgendamentos />} />
              <Route path="/configuracoes/notificacoes" element={<ConfiguracoesNotificacoes />} />
              <Route path="/configuracoes/logs" element={<ConfiguracoesLogs />} />
              <Route path="/configuracoes/monitoramento" element={<ConfiguracoesMonitoramento />} />
              <Route path="/configuracoes/email" element={<ConfiguracoesEmail />} />
              <Route path="/wiki" element={<WikiArtigos />} />
              <Route path="/wiki/artigos" element={<WikiArtigos />} />
              <Route path="/wiki/gerenciar" element={<WikiGerenciar />} />
              <Route path="/wiki/biblioteca" element={<WikiBiblioteca />} />
              <Route path="/ia/base-conhecimento" element={<BaseConhecimento />} />
              <Route path="/ia/prompts-agentes" element={<PromptsAgentes />} />
              <Route path="/ia/fluxo-n8n" element={<FluxoN8n />} />
              <Route path="/ia/ia-documento" element={<IADocumento />} />
              {/* Informativo */}
              <Route path="/informativo/circulando" element={<Circulando />} />
              <Route path="/informativo/imprensa" element={<Imprensa />} />
              <Route path="/informativo/interno" element={<Interno />} />
              <Route path="/informativo/boletim" element={<Boletim />} />
              {/* Projetos */}
              <Route path="/projetos/roadmap" element={<ProjetosRoadmap />} />
              <Route path="/projetos/gestao" element={<ProjetosGestao />} />
              <Route path="/atendimentos/mensagens-ativas" element={<MensagensAtivas />} />
              <Route path="/ia/gerar-audio" element={<GerarAudio />} />
              {/* Comercial */}
              <Route path="/comercial" element={<Navigate to="/comercial/gestao" replace />} />
              <Route path="/comercial/gestao" element={<ComercialGestao />} />
              <Route path="/comercial/cupons" element={<ComercialCupons />} />
              <Route path="/comercial/atualizacao-cadastral" element={<ComercialAtualizacaoCadastral />} />
              <Route path="/comercial/campanhas2026" element={<ComercialCampanhas2026 />} />
              <Route path="/comercial/calculadoras" element={<ComercialCalculadoras />} />
              <Route path="/comercial/cadastro" element={<ComercialCadastro />} />
              <Route path="/comercial/clientes" element={<ComercialClientes />} />
              <Route path="/comercial/clientes/:id" element={<ComercialClienteConta />} />
              <Route path="/comercial/atividades" element={<ComercialAtividades />} />
              <Route path="/comercial/cotacoes" element={<ComercialCotacoes />} />
              <Route path="/comercial/contatos_portal" element={<ComercialContatosPortal />} />
              <Route path="/comercial/cockpit" element={<ComercialCockpit />} />
              {/* Adm */}
              <Route path="/adm/despesas" element={<AdmDespesas />} />
              <Route path="/adm/cadastros" element={<AdmCadastros />} />
              <Route path="/adm/dashboard" element={<AdmDashboard />} />
              {/* Financeiro */}
              <Route path="/financeiro/P&L" element={<FinanceiroPeL />} />
              {/* Qualidade */}
              <Route path="/qualidade/cadastro" element={<QualidadeCadastro />} />
              <Route path="/qualidade/tickets" element={<QualidadeIncidentes />} />
              <Route path="/qualidade/dashboard" element={<QualidadeDashboard />} />
              <Route path="/qualidade/fluxograma" element={<QualidadeFluxograma />}>
                <Route index element={<QualidadeFluxogramaLista />} />
                <Route path=":id" element={<QualidadeFluxogramaEditor />} />
              </Route>
              {/* Social */}
              <Route path="/social/posts" element={<SocialPosts />} />
              {/* Marketing */}
              <Route path="/marketing/clipping" element={<MarketingClipping />} />
              <Route path="/marketing/alertas" element={<MarketingAlertas />} />
              <Route path="/marketing/parametros" element={<MarketingParametros />} />
              <Route path="/marketing/game" element={<MarketingGame />} />
              <Route path="/marketing/estoque" element={<EstoqueGestao />} />
              <Route path="/marketing/solicitacao" element={<MarketingSolicitacao />} />
              <Route path="/marketing/contratos" element={<MarketingContratos />} />
              <Route path="/marketing/orcamento" element={<MarketingPropostas />} />
              <Route path="/marketing/propostas" element={<Navigate to="/marketing/orcamento" replace />} />
              <Route path="/marketing/notas" element={<MarketingNotas />} />
              <Route path="/marketing/financeiro" element={<MarketingFinanceiro />} />
              <Route path="/marketing/despesas" element={<MarketingDespesas />} />
              <Route path="/marketing/materiais" element={<MarketingMateriais />} />
              <Route path="/marketing/relatorios" element={<MarketingRelatorios />} />
              {/* Central de Amparo */}
              <Route path="/central-amparo" element={<Navigate to="/central-amparo/dashboard" replace />} />
              <Route path="/central-amparo/dashboard" element={<CentralAmparoDashboard />} />
              <Route path="/central-amparo/calendario" element={<CentralAmparoCalendario />} />
              <Route path="/central-amparo/triagem" element={<CentralAmparoTriagem />} />
              <Route path="/central-amparo/parametros" element={<CentralAmparoParametros />} />
              <Route path="/central-amparo/especializacoes" element={<Navigate to="/central-amparo/parametros" replace />} />
            </Route>

            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
      </NotificationsProvider>
    </AuthProvider>
  )
}

export default App
